import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Functie } from '../../../model';
import { ContentService } from '../../../services/content/content.service';
import { CompareService } from '../../../services/compare/compare.service';
import { FunctieCardEnum } from './functie-card.enum';

const content = require('./functie-card.content.json');

@Component({
  selector: 'app-functie-card',
  templateUrl: './functie-card.component.html',
  styleUrls: ['./functie-card.component.scss']
})
export class FunctieCardComponent implements OnInit {
  @Input()
  public functie: Functie;

  @Input()
  public showActions: boolean = true;

  @Input()
  public mode: string = FunctieCardEnum.DEFAULT;

  @Input()
  public showMatchPercentage: boolean = false;

  @Output()
  public select: EventEmitter<Functie> = new EventEmitter();

  @Output()
  public changeFunction: EventEmitter<void> = new EventEmitter();

  @Output()
  public preview: EventEmitter<Functie> = new EventEmitter();

  @Output()
  public favorite: EventEmitter<Functie> = new EventEmitter();

  public checked: boolean = false;

  public FunctieCardEnum = FunctieCardEnum;
  public opleidingsniveaus: string;

  private totalItemsInCompareTray: number = 0;

  public constructor(private contentService: ContentService, private compareService: CompareService) {
    this.contentService.loadContent(content);

    this.compareService.getItemsToCompare$().subscribe((itemsToCompare: any[]) => {
      this.compareService.getRequestRemove$().subscribe((requestedItemToRemove: any) => {
        if (requestedItemToRemove === this.functie) {
          this.handleCompareSelection(requestedItemToRemove);
        }
      });
      this.totalItemsInCompareTray = itemsToCompare.length;
    });
  }

  public ngOnInit(): void {
    this.opleidingsniveaus = this.functie.opleidingsniveaus?.join(', ');
  }

  public shorten(string, amount): string {
    if (string.length > amount) {
      return string.substr(0, amount) + '...';
    }
    return string;
  }

  public selectFunctie(): void {
    this.select.emit(this.functie);
  }

  public handleChangeFunction(): void {
    this.changeFunction.emit();
  }

  public handlePreviewClick(): void {
    this.preview.emit(this.functie);
  }

  public handleCompareSelection($event: any): void {
    if ($event.checked) {
      this.compareService.addItemToCompare(this.functie);
      this.checked = true;
    } else {
      this.compareService.removeItemToCompare(this.functie);
      this.checked = false;
    }
  }

  handleFavoriteClick(): void {
    this.favorite.emit(this.functie);
  }
}
